<template>
   <span>
      {{ price }}
      <CurrencySymbol :symbol="symbol" />
   </span>
</template>

<script>
import CurrencySymbol from './CurrencySymbol.vue';

export default {
   name: 'Price',
   components: { CurrencySymbol },
   props: {
      price: {
         type: [Number, String],
         default: 0,
      },
      symbol: {
         type: String,
         default: 'ر.س',
      },
   },
};
</script>